import React from 'react';
import './About.css';

const About = () => {
  return (
    <div>
        <section className='about' id='about'>
          <div className='about-img'>
          <img src='about.png' alt=''></img>
          </div>

          <div className='about-content'>
            <h2 className='heading'>About <span>Me</span></h2>
            <p>Hi, I'm Lakshan Hewagama, a 4th-year Software Engineering undergraduate passionate about building scalable and efficient full-stack web applications. I have strong experience in both backend and frontend development, enabling me to deliver end-to-end solutions that are reliable, user-friendly, and production-ready.

I enjoy working on self-driven projects like VidQuill, E-Payment Tracker, and Sadana TCMS, where I apply and expand my skills in MERN stack, Next.js, Laravel, Node.js, and MongoDB. I’m particularly interested in full-stack development, authentication systems, API design, and modern web solutions.

My goal is to continuously grow as a developer, explore new technologies, and build real-world applications that make an impact. I thrive in collaborative environments, enjoy solving complex problems, and am committed to delivering high-quality full-stack solutions.</p>
          </div>
          
        </section>
    </div>
  )
}

export default About